import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AnnouncementBanner from "./components/AnnouncementBanner";
import ScrollButtons from "./components/ScrollButtons";
import FloatingLiveChat from "./components/FloatingLiveChat";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Services from "./pages/Services";
import HowItWorks from "./pages/HowItWorks";
import Pricing from "./pages/Pricing";
import Help from "./pages/Help";
import About from "./pages/About";
import LegalDisclaimer from "./pages/LegalDisclaimer";
import Questionnaire from "./pages/Questionnaire";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import AdminDashboard from "./pages/AdminDashboard";
import FormsLibrary from "./pages/FormsLibrary";
import InvestmentAdvisor from "./pages/InvestmentAdvisor";
import EnterpriseHub from "./pages/EnterpriseHub";
import InteractiveDemo from "./pages/InteractiveDemo";
import SignIn from "./pages/SignIn";
import Dashboard from "./pages/Dashboard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import RefundPolicy from "./pages/RefundPolicy";
import TestGenerate from "./pages/TestGenerate";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <AnnouncementBanner />
          <Header />
          <main className="min-h-screen">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/forms-library" element={<FormsLibrary />} />
              <Route path="/investment-advisor" element={<InvestmentAdvisor />} />
              <Route path="/enterprise-hub" element={<EnterpriseHub />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/about" element={<About />} />
              <Route path="/help" element={<Help />} />
              <Route path="/legal-disclaimer" element={<LegalDisclaimer />} />
              <Route path="/questionnaire/:service" element={<Questionnaire />} />
              <Route path="/checkout/:serviceId" element={<Checkout />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/demo" element={<InteractiveDemo />} />
              <Route path="/signin" element={<SignIn />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/test-generate/:serviceId" element={<TestGenerate />} />
            </Routes>
          </main>
          <Footer />
          <ScrollButtons />
          <FloatingLiveChat />
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;